import request from "@/util/request";

export function GetEnterpriseSelect(data) {
  return request({
    url: '/api/config/enterprise/GetEnterpriseSelect',
    method: 'GET',
    params: data
  })
}

export function GetDetail(data) {
  return request({
    url: '/api/config/enterprise/GetDetail',
    method: 'GET',
    params: data
  })
}

export function StationGetPollutions(data) {
  return request({
    url: '/api/config/enterprise/StationGetPollutions',
    method: 'GET',
    params: data
  })
}

export function StationGet(data) {
  return request({
    url: '/api/config/enterprise/StationGet',
    method: 'GET',
    params: data
  })
}

export function EnterpriseGet(data) {
  return request({
    url: '/api/config/enterprise/EnterpriseGet',
    method: 'GET',
    params: data
  })
}

export function EnterpriseAddOrUpdate(data) {
  return request({
    url: '/api/config/enterprise/EnterpriseAddOrUpdate',
    method: 'POST',
    data
  })
}

export function EnterpriseRemove(data) {
  return request({
    url: '/api/config/enterprise/EnterpriseRemove',
    method: 'DELETE',
    data
  })
}

export function EnterpriseSummary(data) {
  return request({
    url: '/api/config/enterprise/EnterpriseSummary',
    method: 'GET',
    params: data
  })
}

export function UploadFile(data) {
  return request({
    url: '/api/config/enterprise/UploadFile',
    method: 'POST',
    data
  })
}

export function ImportEnterpriseFile(data) {
  return request({
    url: '/api/config/enterprise/ImportEnterpriseFile',
    method: 'POST',
    data
  })
}

export function DeleteEnterpriseFile(data) {
  return request({
    url: '/api/config/enterprise/DeleteEnterpriseFile',
    method: 'DELETE',
    data
  })
}

export function GetEnterpriseFile(data) {
  return request({
    url: '/api/config/enterprise/GetEnterpriseFile',
    method: 'post',
    data
  })
}
export function GetFileList(data) {
  return request({
    url: '/api/config/enterprise/GetFileList',
    method: 'GET',
    params: data
  })
}
export function GetEnterpriseList(data) {
  return request({
    url: '/api/config/enterprise/GetEnterpriseList',
    method: 'GET',
    params: data
  })
}
export function GetCustomizeTags(data) {
  return request({
    url: '/api/config/enterprise/GetCustomizeTags',
    method: 'GET',
    params: data
  })
}
export function GetEnterpriseTagList(data) {
  return request({
    url: '/api/config/enterprise/GetEnterpriseTagList',
    method: 'POST',
    data
  })
}
export function EnterpriseTagAddOrUpdate(data) {
  return request({
    url: '/api/config/enterprise/EnterpriseTagAddOrUpdate',
    method: 'POST',
    data
  })
}
export function AddOrUpdate(data) {
  return request({
    url: '/api/config/enterprise/AddOrUpdate',
    method: 'POST',
    data
  })
}
export function Remove(data) {
  return request({
    url: '/api/config/enterprise/Remove',
    method: 'DELETE',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/enterpriseConfig.js